import React from 'react'

const Buttons = () => {
    return (
        <div className="image-overlay">
            <div class="buttons-container">
                <img className="heart-button"src="./icons/heart.svg" />
                <img className="play-button"src="./icons/play.svg" />
                <img className="dots-button"src="./icons/dots.svg" />            
            </div>
        </div>
    )
}

export default Buttons